/***** Hovering on items *****/
 var itemHover = function() {
   $('.desktop-nav ul a, ul.work-index__list a').hover(
      function(){ $(this).parent().addClass('force-hover') },
      function(){ $(this).parent().removeClass('force-hover') }
    )
 }

 export default itemHover;



// WEBPACK FOOTER //
// ./source/scripts/modules/item-hover.js